import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";

export const createGlobalOffers = (data) => {
  return server_api.postForm("/commodity/global-offers", toFormData(data));
};
export const getGlobalOffers = (page = 1, pageSize = 30) => {
  return server_api.get(
    `/commodity/global-offers?page=${page}&page_size=${pageSize}`
  );
};
export const updateGlobalOffers = (id, data) => {
  return server_api.patchForm(`/commodity/global-offers/${id}`, toFormData(data));
};
export const updateGlobalOfferMachines = (id, data) => {
  return server_api.post(
    `/commodity/global-offers/${id}/update_machines`,
    data
  );
};
export const deleteGlobalOffers = (data) => {
  return server_api.delete(`/commodity/global-offers/${data.id}`);
};
